<template>
  <v-dialog v-model="dialog" :key="editedItem.id">
    <v-card class="pa-10">
      <v-card-text>
          <h1>{{ $t('storyHub.cloneStory') }}?</h1>
          <p>{{ $t('storyHub.cloneStoryDescription') }}</p>
          <h2> {{ editedItem.name}} </h2>
          <h3> {{ editedItem.chapters ? editedItem.chapters.length : 0 }} Chapters</h3>
          <v-row>
            <v-col>
              <v-btn
                color="accentElementBackground"
                @click="dialog = false"
              >{{ $t('forms.cancel') }}</v-btn>
            </v-col>
            <v-col>
              <ApolloMutation :mutation="(gql) => gql`
                mutation CloneStory($id: ID!) {
                  cloneStory(input: { id: $id setCurrentUserOwner: true}) {
                    story {
                      id
                      name
                      description
                      priceCents
                      status {
                        id
                      }
                      createdAt
                      updatedAt
                      chapters {
                        id
                        name
                        createdAt
                        updatedAt
                      }
                    }
                  }
                }`"
                :variables="{
                  id: editedItem ? editedItem.id : '',
                  setCurrentUserOwner: true,
                }"
                @done="success"
                >
                <template v-slot="{ mutate, loading, error }">
                  <v-btn :loading="loading" :disabled="loading" color="accent" @click="mutate"
                  >{{ $t('storyHub.clone') }}</v-btn>
                  {{ error }}
                </template>
              </ApolloMutation>
            </v-col>
          </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    editedItem: Object,
    enableDialog: Boolean,
  },
  data() {
    return {
      dialog: false,
    };
  },
  watch: {
    enableDialog(newValue) {
      if (newValue) {
        this.dialog = true;
      }
    },
    dialog(newValue) {
      if (!newValue) {
        this.$emit('reset', this.dialog);
      }
    },
  },
  methods: {
    success(data) {
      this.dialog = false;
      const story = data.data.cloneStory.story
      // navigate to the new story
      this.$router.push({ name: 'basic-info', params: { id: story.id.substring(story.id.indexOf('/', 1) + 1) } });
    },
  }
}
</script>